var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAvla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332.13 332.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0031e2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ISO_AVLA_4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.74,305.77c0,38.63,18.4,51.51,44.88,51.51,22.44,0,36.8-8.84,45.27-17.66V267.49c-7.37-7.36-20.61-15.8-42.3-15.8C366.14,251.69,347.74,270.07,347.74,305.77Z",
    transform: "translate(-229.93 -139.93)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396,139.93A166.07,166.07,0,1,0,562.07,306,166.07,166.07,0,0,0,396,139.93ZM482,397H441.56l-1.84-20.62c-12.88,11.78-31.27,22.44-58.13,22.44-42.33,0-78-22.81-78-93.83,0-66.23,37.52-97.5,84.62-97.5,26.12,0,43.43,9.57,54.83,20.24l5.15-18.39H482Z",
    transform: "translate(-229.93 -139.93)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvla);
export default __webpack_public_path__ + "static/media/icon_avla.7dba1a4374701b78975fb70ea2f538ce.svg";
export { ForwardRef as ReactComponent };